<script lang="ts">
    export let message: string
    export let details: string
</script>

<h3 class="modal_heading">
    <i class="fas fa-exclamation-circle"></i>
    Whoops!
</h3>
<p class="modal_p white_text">
    {message}
</p>
{#if details}
    <pre class="modal_p white_text">
        {details}
    </pre>
    <i class="modal_p white_text">These details might help us debug the error.</i>
{/if}

<style>
    h3 {
        margin-top: 0px;
    }

    pre {
        background-color: var(--button-color);
        color: white;
        padding: 10px;
        border-radius: var(--border-radius);
        word-wrap: break-word;
        white-space: pre-wrap;
    }

    i {
        font-size: 0.9rem;
        opacity: 0.5;
    }
</style>

